import { lazy } from 'react'
import AuthGuard from '../components/AuthGuard.jsx'
import TeacherGuard from '../components/TeacherGuard.jsx'

const Dashboard    = lazy(() => import('../screens/Dashboard.jsx'))
const Login        = lazy(() => import('../screens/Login.jsx'))
const LevelIndex   = lazy(() => import('../screens/LevelIndex.jsx'))
const Progreso     = lazy(() => import('../screens/Progreso.jsx'))
const Historial    = lazy(() => import('../screens/Historial.jsx'))
const MetricaDetalle = lazy(() => import('../screens/MetricaDetalle.jsx'))
const Comparativas = lazy(() => import('../screens/Comparativas.jsx'))
const Board        = lazy(() => import('../screens/Board.jsx'))
const UploadTipos  = lazy(() => import('../screens/UploadTipos.jsx'))
const Waitlist     = lazy(() => import('../screens/Waitlist.jsx'))
const Perfil       = lazy(() => import('../screens/Perfil.jsx'))
const Premium      = lazy(() => import('../screens/Premium.jsx'))
const Onboarding   = lazy(() => import('../screens/Onboarding.jsx'))
const Ranking      = lazy(() => import('../screens/Ranking.jsx'))
const Grupos       = lazy(() => import('../screens/Grupos.jsx'))
const GrupoDetalle = lazy(() => import('../screens/GrupoDetalle.jsx'))
const UnirseGrupo  = lazy(() => import('../screens/UnirseGrupo.jsx'))
const RetoPublico  = lazy(() => import('../screens/RetoPublico.jsx'))
const Informe      = lazy(() => import('../screens/Informe.jsx'))
const Admin        = lazy(() => import('../screens/Admin.jsx'))
const Labeling     = lazy(() => import('../screens/Labeling.jsx'))
const Alumnos      = lazy(() => import('../screens/Alumnos.jsx'))
const MiPlan       = lazy(() => import('../screens/MiPlan.jsx'))
const Confirmar    = lazy(() => import('../screens/Confirmar.jsx'))
const Partidos     = lazy(() => import('../screens/Partidos.jsx'))
const Partido      = lazy(() => import('../screens/Partido.jsx'))
const Torneos      = lazy(() => import('../screens/Torneos.jsx'))
const Torneo       = lazy(() => import('../screens/Torneo.jsx'))
const TorneoImprimir = lazy(() => import('../screens/TorneoImprimir.jsx'))
const TorneoCodigo = lazy(() => import('../screens/TorneoCodigo.jsx'))
const RankingClub  = lazy(() => import('../screens/RankingClub.jsx'))
const ClubPanel    = lazy(() => import('../screens/ClubPanel.jsx'))

function guarded(element) {
  return <AuthGuard>{element}</AuthGuard>
}

export const routes = [
  // Rutas públicas
  { path: '/login',      labelKey: 'nav.analysis',  element: <Login /> },
  { path: '/waitlist',   labelKey: 'nav.analysis',  element: <Waitlist /> },
  // Enlace del correo de alta (plantilla de Supabase): ver Confirmar.jsx
  { path: '/confirmar',  labelKey: 'nav.analysis',  element: <Confirmar /> },
  { path: '/onboarding', labelKey: 'nav.analysis',  element: <Onboarding /> },
  { path: '/admin',      labelKey: 'nav.admin',     element: <Admin /> },
  { path: '/labeling',   labelKey: 'nav.labeling',  element: guarded(<Labeling />) },

  // Rutas privadas
  { path: '/dashboard',    labelKey: 'nav.dashboard', element: guarded(<Dashboard />) },
  { path: '/upload-tipos', labelKey: 'nav.strokes',   element: guarded(<UploadTipos />) },
  // Mismo orden que la barra inferior del móvil (BottomNav.jsx)
  { path: '/historial',    labelKey: 'nav.history',   element: guarded(<Historial />) },
  { path: '/level',        labelKey: 'nav.myLevel',   element: guarded(<LevelIndex />) },
  { path: '/progreso',     labelKey: 'nav.progress',  element: guarded(<Progreso />) },
  {
    path: '/metrica/:metricKey',
    navPath: '/metrica/timing',
    labelKey: 'nav.metric',
    element: guarded(<MetricaDetalle />),
  },
  { path: '/comparativas', labelKey: 'nav.compare',   element: guarded(<Comparativas />) },
  { path: '/board',        labelKey: 'nav.board',     element: guarded(<Board />) },
  { path: '/perfil',       labelKey: 'nav.myLevel',   element: guarded(<Perfil />) },
  { path: '/premium',      labelKey: 'nav.analysis',  element: guarded(<Premium />) },
  { path: '/ranking',           labelKey: 'nav.ranking',  element: guarded(<Ranking />) },
  { path: '/grupos',            labelKey: 'nav.groups',   element: guarded(<Grupos />) },
  { path: '/grupos/:id',        labelKey: 'nav.groups',   element: guarded(<GrupoDetalle />) },
  { path: '/informe',           labelKey: 'nav.report',   element: guarded(<Informe />) },
  // Partidos de club (engine/club_matches.py)
  { path: '/partidos', labelKey: 'nav.analysis', element: guarded(<Partidos />) },
  { path: '/partido/:id', labelKey: 'nav.analysis', element: guarded(<Partido />) },
  // Torneos Americanos (engine/tournaments.py)
  { path: '/torneos', labelKey: 'nav.analysis', element: guarded(<Torneos />) },
  { path: '/torneo/:id', labelKey: 'nav.analysis', element: guarded(<Torneo />) },
  { path: '/torneo/:id/imprimir', labelKey: 'nav.analysis', element: guarded(<TorneoImprimir />) },
  { path: '/club-ranking/:id', labelKey: 'nav.analysis', element: guarded(<RankingClub />) },
  // Panel del club para sus administradores (engine/club_members.py)
  { path: '/club/:id', labelKey: 'nav.analysis', element: guarded(<ClubPanel />) },
  { path: '/plan',              labelKey: 'nav.plan',     element: guarded(<MiPlan />) },
  { path: '/alumnos',           labelKey: 'nav.students', element: guarded(<TeacherGuard><Alumnos /></TeacherGuard>) },
  // Públicas: flujos de invitación/reto sin sesión
  { path: '/grupo/unirse/:code', labelKey: 'nav.groups', element: <UnirseGrupo /> },
  { path: '/reto/:code',         labelKey: 'nav.groups', element: <RetoPublico /> },
  { path: '/t/:code',            labelKey: 'nav.analysis', element: <TorneoCodigo /> },
]